import React from 'react';
//mui
import { Box } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { makeStyles } from '@mui/styles';
import CostCalcRow from './CostCalcRow';
import { getNumberComma } from '../../../utils/numberUtils';
const useStyles = makeStyles({
  table: {
    '& .MuiTableCell-root': {
      border: '1px solid rgba(224, 224, 224, 1)',
      align: 'center',
    },
  },
});

const CostCalcLockList = ({ costs }) => {
  const classes = useStyles();

  if (!costs && costs?.length === 0) {
    return null;
  }

  return (
    <Box sx={{ overflow: 'auto', my: 1 }}>
      <TableContainer
        size="small"
        className={classes.table}
        sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}
      >
        <Table padding="none">
           <colgroup>
            <col style={{ width: '40px' }} />
            <col style={{ width: '270px' }} />
            <col style={{ width: '40px' }} />
            <col style={{ width: '40px' }} />
            <col style={{ width: '40px' }} />
            <col style={{ width: '120px' }} />
            <col style={{ width: '120px' }} />
            <col style={{ width: '120px' }} />
            <col style={{ width: '120px' }} />
            <col style={{ width: '120px' }} />
            <col style={{ width: '120px' }} />
            <col style={{ width: '110px' }} /> 
            <col style={{ width: '70px' }} />  
            <col style={{ width: '60px' }} />
            <col style={{ width: '150px' }} />
          </colgroup>
                    <TableHead>
            <TableRow>
                <TableCell sx={{ width: 40, minWidth: 40, maxWidth: 40 }} rowSpan={2} align="center">No</TableCell>
                  <TableCell sx={{ width: 280, minWidth: 280, maxWidth: 280 }} rowSpan={2} align="center">매출내용(제품 또는 용역명)</TableCell>
                  <TableCell sx={{ width: 40, minWidth: 40, maxWidth: 40 }} rowSpan={2} align="center">사양</TableCell>
                  <TableCell sx={{ width: 40, minWidth: 40, maxWidth: 40 }} rowSpan={2} align="center">수량</TableCell>
                  <TableCell sx={{ width: 40, minWidth: 40, maxWidth: 40 }} rowSpan={2} align="center">단위</TableCell>

                  <TableCell colSpan={3} align="center">매출</TableCell>
                  <TableCell colSpan={3} align="center">매입</TableCell>
                  <TableCell sx={{ width: 130, minWidth: 130, maxWidth: 130 }} colSpan={2} align="center">매출이익</TableCell>

                  <TableCell sx={{ width: 60, minWidth: 60, maxWidth: 60 }} rowSpan={2} align="center">아이템</TableCell>
                  <TableCell sx={{ width: 140, minWidth: 140, maxWidth: 140 }} rowSpan={2} align="center">매입처</TableCell>
              </TableRow>
              
              <TableRow>
                <TableCell align="center">매출단가<br/>(VAT별도)</TableCell>
                <TableCell sx={{backgroundColor: '#f5f4f4',}} align="center">매출금액<br/>(VAT별도)</TableCell>
                <TableCell sx={{backgroundColor: '#f5f4f4',}} align="center">매출금액<br/>(VAT포함)</TableCell>

                <TableCell align="center">매입단가<br/>(VAT별도)</TableCell>
                
                <TableCell sx={{backgroundColor: '#f5f4f4',}} align="center">매입금액<br/>(VAT별도)</TableCell>
                <TableCell sx={{backgroundColor: '#f5f4f4',}} align="center">매입금액<br/>(VAT포함)</TableCell>
                <TableCell sx={{ width: 130, minWidth: 130, maxWidth: 130, fontSize: '0.875rem' }} align="center">매출이익<br/>(VAT별도)</TableCell>
                <TableCell sx={{  width: 30, minWidth: 30, maxWidth: 30, backgroundColor: '#f5f4f4', fontSize: '0.875rem' }} align="center">이익율</TableCell>
              </TableRow>
            </TableHead>
          <TableBody>
            {costs && (
              <>
                {/* 1. 개별 행 및 매입처별 소계 루프 */}
                {costs.map((cost, index, array) => {
                  const rows = [];

                  // 개별 데이터 행 추가
                  rows.push(<CostCalcRow key={cost.id || index} cost={cost} index={index} />);

                  // 매입처별 소계 계산 및 삽입 로직
                  const nextItem = array[index + 1];
                  if (!nextItem || cost.sellPartnerUuid !== nextItem.sellPartnerUuid) {
                    
                    const partnerRows = array.filter(item => item.sellPartnerUuid === cost.sellPartnerUuid);
                    
                    const subSale = partnerRows.reduce((sum, item) => sum + (Number(item.saleVal) || 0), 0);
                    const subSaleIn = partnerRows.reduce((sum, item) => sum + (Number(item.saleValIn) || 0), 0);
                    const subBuy = partnerRows.reduce((sum, item) => sum + (Number(item.buyVal) || 0), 0);
                    const subBuyIn = partnerRows.reduce((sum, item) => sum + (Number(item.priceValIn) || 0), 0);
                    const subProfit = partnerRows.reduce((sum, item) => sum + (Number(item.saleProfit) || 0), 0);
                    const subPct = subSale !== 0 ? (subProfit / subSale) * 100 : 0;

                    rows.push(
                      <TableRow 
                        key={`subtotal-${index}`} 
                        sx={{ 
                          backgroundColor: '#f1f3f5', // 소계 배경색 (그레이)
                          height: '32px',
                          '& .MuiTableCell-root': { 
                            fontWeight: 700, 
                            fontSize: '0.8125rem', 
                            py: 0.5, 
                            borderTop: '1px solid #dee2e6',
                            borderBottom: '2px solid #dee2e6',
                            fontVariantNumeric: 'tabular-nums' 
                          } 
                        }}
                      >
                        <TableCell colSpan={5} align="right" sx={{ pr: 2 }}>{cost.sellPartnerNm || '기타'} 소계 :</TableCell>
                        <TableCell />
                        <TableCell align="right" sx={{ pr: '4px !important' }}>{getNumberComma(subSale)}</TableCell>
                        <TableCell align="right" sx={{ pr: '4px !important' }}>{getNumberComma(subSaleIn)}</TableCell>
                        <TableCell />
                        <TableCell align="right" sx={{ pr: '4px !important' }}>{getNumberComma(subBuy)}</TableCell>
                        <TableCell align="right" sx={{ pr: '4px !important' }}>{getNumberComma(subBuyIn)}</TableCell>
                        <TableCell align="right" sx={{ pr: '4px !important' }}>{getNumberComma(subProfit)}</TableCell>
                        <TableCell align="center">{subPct.toFixed(2)} %</TableCell>
                        <TableCell colSpan={2} />
                      </TableRow>
                    );
                  }
                  return <React.Fragment key={`group-${cost.id || index}`}>{rows}</React.Fragment>;
                })}

                {/* 2. 최하단 전체 총합계 행 */}
                {costs.length > 0 && (() => {
                  const totalSale = costs.reduce((sum, item) => sum + (Number(item.saleVal) || 0), 0);
                  const totalSaleIn = costs.reduce((sum, item) => sum + (Number(item.saleValIn) || 0), 0);
                  const totalBuy = costs.reduce((sum, item) => sum + (Number(item.buyVal) || 0), 0);
                  const totalBuyIn = costs.reduce((sum, item) => sum + (Number(item.priceValIn) || 0), 0);
                  const totalProfit = totalSale - totalBuy;

                  return (
                    <TableRow 
                      sx={{ 
                        backgroundColor: '#e3f2fd', // 전체 합계 배경색 (블루)
                        height: '40px',
                        '& .MuiTableCell-root': {
                          borderTop: '2px solid #90caf9',
                          borderBottom: '2px solid #90caf9',
                          py: 1,
                          fontVariantNumeric: 'tabular-nums'
                        }
                      }}
                    >
                      <TableCell colSpan={5} align="right" sx={{ fontWeight: 900, fontSize: '0.85rem', pr: 2, color: '#333' }}>
                        합계 :
                      </TableCell>
                      <TableCell />
                      <TableCell align="right" sx={{ fontWeight: 800, fontSize: '0.9rem', pr: '4px !important', color: '#01579b' }}>
                        {getNumberComma(totalSale)}
                      </TableCell>
                      <TableCell align="right" sx={{ fontWeight: 800, fontSize: '0.9rem', pr: '4px !important', color: '#01579b' }}>
                        {getNumberComma(totalSaleIn)}
                      </TableCell>
                      <TableCell />
                      <TableCell align="right" sx={{ fontWeight: 800, fontSize: '0.9rem', pr: '4px !important', color: '#01579b' }}>
                        {getNumberComma(totalBuy)}
                      </TableCell>
                      <TableCell align="right" sx={{ fontWeight: 800, fontSize: '0.9rem', pr: '4px !important', color: '#01579b' }}>
                        {getNumberComma(totalBuyIn)}
                      </TableCell>
                      <TableCell align="right" sx={{ fontWeight: 900, fontSize: '0.9rem', color: '#01579b', pr: '4px !important' }}>
                        {getNumberComma(totalProfit)}
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: 800, fontSize: '0.9rem', color: '#01579b' }}>
                        {totalSale !== 0 ? ((totalProfit / totalSale) * 100).toFixed(2) : '0.00'}%
                      </TableCell>
                      <TableCell colSpan={2} />
                    </TableRow>
                  );
                })()}
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CostCalcLockList;
